export const summarizerAdapter = (data, meta) => {
  const appliedFilters = {
    langs: 'filter:language',
    content_tag_ids: 'filter:contentsTag',
    extracted_phrases: 'filter:wordCloud',
    extracted_hashtags: 'filter:hashtagCloud',
    sentiments: 'filter:contentsSentiment',
    //advert_noise: instagram
    min_advert_noise: 'filter:advertLevel',
    max_advert_noise: 'filter:advertLevel',
    //relation_influence: twitter, telegram, news, instagram
    resource_influence_categories: 'filter:contentBasedOn',
    //view: telegram
    min_view: 'filter:contentBasedOn',
    max_view: 'filter:contentBasedOn',
    //lik: twitter, instagram
    min_like: 'filter:contentBasedOn',
    max_like: 'filter:contentBasedOn',
    //copy: twitter
    min_copy: 'filter:contentBasedOn',
    max_copy: 'filter:contentBasedOn',
    //comment: instagram
    min_comment: 'filter:contentBasedOn',
    max_comment: 'filter:contentBasedOn',
    //source: twitter, telegram, news
    source: 'filter:contentType',
    //categories: twitter, telegram, news, instagram
    categories: 'filter:contentCategory',
    sub_categories: 'filter:contentCategory',
    //resource_categories: newspaper
    resource_categories: 0,
    //tag_id: news, twitter, telegram, newspaper, instagram, instagramComment
    tag_id: 'filter:resourceCategory',
    //resource_ids: instagramComment
    post_resource_ids: 'filter:resourceSearch',
    //age: twitter, instagram
    m3_age: 'filter:ageRange',
    gender: 'filter:gender',
    media_types: 'filter:mediaType',
  };

  const filters = [
    ...new Set(
      Object.entries(data.request_details)
        .filter(
          ([key, value]) => value && value.length !== 0 && appliedFilters[key]
        )
        .map(([key]) => appliedFilters[key])
    ),
  ];

  return { ...data, filters, meta };
};
